// @flow

import React from 'react';
import { connect } from 'react-redux';
import { TileSelect, Tile } from '../tileSelect';
import { SmallConfigPackage } from '../configPackage';
import { getPackages } from '../../../../store/configuration/actives';
import { isSoldOutPackage } from '../../../../store/pdb/selectors';
import {
  getActivePackageId,
  selectPackage,
} from '../../../../store/configuration';
import type { Package } from '../../../../types/pdb';

type OwnProps = {|
  blocksPerRow: number,
  variant: ?string, // eslint-disable-line react/no-unused-prop-types
  pdbId: ?string, // eslint-disable-line react/no-unused-prop-types
|};

type StateProps = {|
  packages: Array<Package>,
  activePackage: ?number,
|};

type DispatchProps = {|
  setPackage: Function,
|};

type Props = {|
  ...OwnProps,
  ...StateProps,
  ...DispatchProps,
|};

const Packages = ({
  packages, activePackage, setPackage, blocksPerRow,
}: Props) => (
  <TileSelect>

    {packages.map((pdbPackage: Package) => {
      const {
        id,
        name,
        price,
        best_choice,
        default_image,
      } = pdbPackage;
      return (
        <Tile
          key={id}
          active={activePackage === id}
          onClick={() => { if (!isSoldOutPackage(pdbPackage)) setPackage(id); }}
          blocksPerRow={blocksPerRow}
          blockCount={packages.length}
          mostChosen={best_choice}
          variant="small"
        >
          <SmallConfigPackage
            title={name || ''}
            price={parseInt(price, 10)}
            active={activePackage === id}
            imgSrc={default_image && default_image.url.replace('__width__', '80')}
            soldOut={isSoldOutPackage(pdbPackage) || false}
            variant="small"
          />
        </Tile>
      );
    })}
  </TileSelect>
);

const mapStateToProps = (state: any, { pdbId }: OwnProps): StateProps => ({
  packages: getPackages(state, pdbId),
  activePackage: getActivePackageId(state, pdbId),
});

const mapDispatchToProps = (dispatch: Function, { pdbId }: OwnProps): DispatchProps => ({
  setPackage: (id: number) => dispatch(selectPackage(id, pdbId)),
});

export default connect<Props, OwnProps, StateProps, DispatchProps, any, any>(
  mapStateToProps,
  mapDispatchToProps,
)(Packages);
